import Constant from '@/common/constant/Constant';
import QAListTicket from '../ticketList/customerSide/QAListTicket';
import HelpDeskTicketList from '../ticketList/helpdeskSide/HelpDeskTicketList';

export default function TicketList(props) {
    return (
        <>
            {props.ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER && <QAListTicket {...props}/>}

            {props.ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK && (
                <HelpDeskTicketList {...props}/>
            )}
        </>
    );
}